export default __webpack_public_path__ + "static/media/clothes-0.db7b7fb4.svg";